import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  bg: {
    background: theme.palette.background.bg,
    padding: "5px 15px",
  },
  searchFormContainer: {
    padding: "15px 0",
  },
}));
